import { useEffect } from 'react';
import { hookstate, useHookstate } from '@hookstate/core';
import Storage from 'localStorage';
import { useHistory } from 'react-router-dom';
import { getUser } from '../../services/user';
import { GetChatHistory, GetListProjects } from '../../services/seenapse';
import useAddProjectStore from './useAddProjectStore';
import { parseJwt } from '../../utils/Utils';

const initialState = hookstate({
  isLoading: false,
  loadingHistory: false,
  projects: [],
  projectHistory: [],
  user: null,
});

export default function useProjectStore(userId) {
  const history = useHistory();
  const { onOpenDialog } = useAddProjectStore();

  const state = useHookstate(initialState);

  useEffect(() => {
    getUser(userId)
      .then((response) => {
        const token = Storage.getItem('token') || '';
        const parseToken = token && parseJwt(token);
        if (!response.data.is_logged_in && parseToken && parseToken.type === 'sso') {
          window.location = '/logout';
          return;
        }
        
        state.user.set(response.data);
      }).catch((error) => {
        console.log(error);
      });
  }, [userId]);

  const onHandleChat = (projectUid, description) => {
    history.push({
      pathname: `/ai/project/chat/${projectUid}`,
      search: `?project=${description}`,
    });
  };

  const getListProjects = (props) => {
    state.isLoading.set(true);
    GetListProjects(userId)
      .then(({ data: { data } }) => {
        state.projects.set(data);
        if (data.length === 0) {
          onOpenDialog();
          Storage.setItem('mode', 'form');
          return;
        }
        if (data.length > 0) {
          const projectsActive = data.filter(project => project.status === 1);
          if (projectsActive.length === 0) {
            onOpenDialog();
            Storage.setItem('mode', 'form');
            return;
          }
          const projectActive = projectsActive[0];
          if (!props.modalStore.isOpenAvatarMenu || !props.modalStore.isOpenMenuExtend) {
            onHandleChat(projectActive.uid, projectActive.description);
          }
          Storage.setItem('mode', 'chat');
        }
      })
      .catch(error => console.error(error))
      .finally(() => state.isLoading.set(false));
  };

  const getChatHistory = ({ chatUid, initialLoading = true, retry = false }) => {
    state.loadingHistory.set(initialLoading);
    GetChatHistory({ uid: chatUid, retry })
      .then(response => state.projectHistory.set(response.data.data))
      .catch(error => console.error(error))
      .finally(() => state.loadingHistory.set(false));
  };

  const onChangeChatValue = (value) => {
    const parseProjectHistory = JSON.parse(JSON.stringify(state.projectHistory.get()));
    const newHistory = [...parseProjectHistory, {
      content: value,
      inserted_a: new Date(),
      role: 'user',
      status: 1,
    }];
    state.projectHistory.set(newHistory);
  };


  const parseProjectHistory = JSON.parse(JSON.stringify(state.projectHistory.get()));
  const parseProjects = JSON.parse(JSON.stringify(state.projects.get()));

  return {
    ...state.get(),
    projectHistory: parseProjectHistory,
    projects: parseProjects,
    getListProjects,
    getChatHistory,
    onChangeChatValue,
  };
}



// WEBPACK FOOTER //
// ./src/hooks/store/useProjectStore.js